// Import internal
import { Common } from './common.model';
import { Embedded, EmbeddedUser, toUserEmbedded, toUsersEmbedded } from './embed.model';

export class App extends Common {
    declare public id: string;
    public name: string;
    public category: AppCategory;
    public isPublic: boolean;
    public owners: string[];
    public logo: string;
    public homepageUrl: string;
    public redirectUrl: string;

    constructor(data: any) {
        super(data);
        this.id = data.id;
        this.name = data.name;
        this.category = data.category;
        this.isPublic = data.isPublic;
        this.owners = data.owners;
        this.logo = data.logo && data.logo.length ? data.logo : '';
        this.homepageUrl = data.homepageUrl;
        this.redirectUrl = data.redirectUrl;
    }

    public static toCustomApp<T extends embed>(data: App, embedded: Embedded, customFields: T[]): EmbedApp<T> {
        const customData = customFields.reduce((acc, field: embed) => {
            acc[field] = configuration[field].transform(data, embedded);
            return acc;
        }, {});
        return { ...new App(data), ...customData } as EmbedApp<T>;
    }
}

export interface EmbedProperties {
    $createdBy: EmbeddedUser;
    $updatedBy: EmbeddedUser;
    $owners: EmbeddedUser[];
}

export type embed = keyof EmbedProperties;

export type EmbedApp<T extends embed> = App & Partial<Pick<EmbedProperties, T>>;

export const configuration: { [K in embed]: { embed: string; transform: (app: App, embedded: Embedded) => EmbedProperties[K] } } = {
    $createdBy: {
        embed: 'users',
        transform: (data: App, embedded: Embedded): EmbeddedUser => toUserEmbedded(data, 'createdBy', embedded),
    },
    $updatedBy: {
        embed: 'users',
        transform: (data: App, embedded: Embedded): EmbeddedUser => toUserEmbedded(data, 'updatedBy', embedded),
    },
    $owners: {
        embed: 'users',
        transform: (data: App, embedded: Embedded): EmbeddedUser[] => toUsersEmbedded(data, 'owners', embedded),
    },
};

export enum AppCategory {
    CUSTOMER_PORTAL = 'CUSTOMER_PORTAL',
    MONITORING = 'MONITORING',
    FILE_SHARING = 'FILE_SHARING',
    SECURITY = 'SECURITY',
}
